const InterviewType = {
  ONLINE: 'Online',
  OFFLINE: 'Face-to-face',
};

module.exports = InterviewType;
